import type { QueryFilter } from '@domain/schemas/filters.schema';

const isActiveFilter = (f: QueryFilter): boolean =>
  f.values.length > 0 || f.comparator === 'ex' || f.comparator === 'nex';

export const serializeQueryFilters = (filters: QueryFilter[]): string | undefined => {
  const active = filters.filter(isActiveFilter);
  if (active.length === 0) return undefined;
  return JSON.stringify(active);
};
